export default __webpack_public_path__ + "static/media/band1.de80b784.jfif";